import React, { useContext, useState} from 'react'
import './login.scss'
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { auth, db } from '../../firebase'
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { Link } from 'react-router-dom'
import { doc, getDoc } from 'firebase/firestore';


export const Login = () => {

  const [ error, setError ] = useState(false);
  const [ email, setEmail ] = useState("");
  const [ password, setPassword ] = useState("");

  const navigate = useNavigate()

   const { dispatch } = useContext(AuthContext)

   const [adminStatus, setAdminStatus] = useState("")

   const [adminId, setAdminId] = useState("")



    // if(adminStatus === "inactive"){

              //   return alert('Your account is inactive, contact Admin')

              //   // signOut()

              // }


  const getAdminStatus = async(id) => {

      if(adminStatus === "inactive"){

        return alert('Your account is inactive, contact Admin')

        signOut()

      }



      // const docRef = doc(db, "admins", id);

      // const docSnap = await getDoc(docRef);

      
      // if (docSnap.exists()) {

      //   // console.log("Document data:", docSnap.data());
      //   setAdminStatus(docSnap.data().status)
      //   // console.log(userData)
      // } else {
      //   // doc.data() will be undefined in this case
      //   console.log("No such document!");
      // }
  }

  // console.log('admin status:  ', adminStatus)

  const handleLogin = (e) => { 
    
      e.preventDefault();

      signInWithEmailAndPassword(auth, email, password)

      .then((userCredential) => {
        
         const user = userCredential.user;

         setAdminId(user.uid)

            // dispatch({type:"LOGIN", payload:user})
  
            // navigate("/")



          auth.currentUser.getIdTokenResult()

          .then((idTokenResult) => {
            // Confirm the user is an Admin.
            if (!!idTokenResult.claims.admin) {

              getAdminStatus(adminId)

              // if(adminStatus === "inactive"){

              //   return alert('Your account is inactive, contact Admin')

              //   // signOut()

              // }

              

              // else{

              //   alert('user is an admin')

              //   console.log('an admin: ', idTokenResult )
  
              //   dispatch({type:"LOGIN", payload:user})
  
              //   navigate("/")

              // }
 

              alert('Your have access, click ok to continue')

              console.log('an admin: ', idTokenResult )

              dispatch({type:"LOGIN", payload:user})

              navigate("/")
            } else {

              alert('You are not an admin')

              console.log('an subadmin: ', idTokenResult.claims)
             

            }
          })
          .catch((error) => {
            console.log(error);
          });
        
        
      })
      .catch((error) => {

        setError(true)

        
      });

  };


  console.log(adminId)

  return (
    <div className='login'>
      
      <fieldset>
        <legend>Chillaxia Admin</legend>

        <form onSubmit={handleLogin}>
          <input type="email" placeholder="Email" onChange={e => setEmail(e.target.value)}/>
          <input type="password" placeholder='Password'  onChange={e => setPassword(e.target.value)}/>
          <Link to="/forgotPwd" style={{textDecoration:'none'}}>
            <div className='forgotPwd'>
                <div>Forgot Password</div>
            </div>
          </Link>
          <button type="submit">Login</button>
          <span>{error && "Wrong email or password"}</span>
        </form>


      </fieldset>

    </div>
  )
}
